import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-base64Image',
  templateUrl: './base64Image.component.html',
  styleUrls: []
})
export class Base64ImageComponent implements OnChanges {
  @Input() imageType: string; // Default to 'gif', but can be changed to 'png', 'jpeg', etc.
  @Input() base64Image: string;
  @Input() fileName: string;
  @Input() altText: string;
  protected safeImageUrl: SafeUrl;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.base64Image) {
      this.imageType = this.imageType ? this.imageType : 'gif';
      this.base64Image = changes.base64Image.currentValue;
      if (!this.altText && this.fileName) {
        this.altText = `Image ${this.imageType}`;
      }
      else {
        this.altText = this.altText ? this.altText : this.fileName;
      }
      this.safeImageUrl = this.sanitizer.bypassSecurityTrustUrl(`data:image/${this.imageType};base64,${this.base64Image}`);
    }

  }
}
